import { render, staticRenderFns } from "./ReturnForm.vue?vue&type=template&id=428781f6&scoped=true"
import script from "./ReturnForm.vue?vue&type=script&lang=js"
export * from "./ReturnForm.vue?vue&type=script&lang=js"
import style0 from "./ReturnForm.vue?vue&type=style&index=0&id=428781f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428781f6",
  null
  
)

export default component.exports